<template>
  <div>
    <div class="display-flex justify-space-between align-center">
      <span class="title font-weight-600">Discover</span>
      <img src="../../assets/mobile/icon/search.svg" :width="20" :height="20" />
    </div>

    <div class="discover__type display-flex gap-8 align-center full-width my-3">
      <div
        class="discover__type__item bg-black text-white display-flex justify-center align-center"
      >
        Trending
      </div>
      <div
        class="discover__type__item display-flex justify-center align-center"
      >
        New
      </div>
      <div
        class="discover__type__item display-flex justify-center align-center"
      >
        Popular
      </div>
    </div>

    <div class="horizontal-scroll mt-3">
      <div
        v-for="(item, index) in categoryList"
        :key="index"
        class="discover__category horizontal-scroll__item display-flex justify-center align-center mr-2 px-4"
        :class="{ 'bg-black text-white': item.active }"
      >
        {{ item.text }}
      </div>
    </div>

    <div class="discover__play">
      <div class="relative">
        <div class="discover__play__image">
          <img
            src="../../assets/mobile/discoverm.png"
            width="100%"
            height="100%"
          />
        </div>
        <div
          class="absolute discover__play__btn display-flex align-center justify-space-between"
        >
          <div
            class="discover__play__btn--previous display-flex align-center justify-center"
          >
            <img
              src="../../assets/mobile/icon/player_previous.svg"
              width="20px"
              height="20px"
            />
          </div>
          <div
            class="discover__play__btn--next display-flex align-center justify-center"
          >
            <img
              src="../../assets/mobile/icon/player_next.svg"
              width="20px"
              height="20px"
            />
          </div>
        </div>
      </div>
      <div
        @click="$router.push({ name: 'PlayerMobile' })"
        class="display-flex align-center gap-8 discover__play__content"
      >
        <img src="../../assets/mobile/icon/play.svg" :width="42" :height="42" />
        <div>
          <div class="text-poppins-18 text-black font-weight-500">
            Wonder Where We Land
          </div>
          <div class="text-poppins-16 text-gray font-weight-500">Sbtkrt</div>
        </div>
      </div>
      <div class="discover__play-1"></div>
      <div class="discover__play-2"></div>
    </div>

    <div class="text-poppins-15 my-5 text-center">
      Swipe left for more, swipe right to save
    </div>
    <div class="mb-5"></div>

    <Footer />
  </div>
</template>

<script>
import Footer from "./components/footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      categoryList: [
        {
          text: "All",
          active: true,
        },
        {
          text: "Rap / Hip Hop",
          active: false,
        },
        {
          text: "House",
          active: false,
        },
        {
          text: "Electronic",
          active: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #000;
  font-size: 24px;
  line-height: 70%;
  letter-spacing: -0.48px;
}
.discover {
  &__type {
    &__item {
      border-radius: 5px;
      background: rgba(0, 0, 0, 0.08);
      color: rgba(0, 0, 0, 0.8);
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
      letter-spacing: -0.14px;
      width: calc(100% / 3);
      height: 30px;
    }
  }
  &__category {
    border: 1px solid rgba(0, 0, 0, 0.6);
    height: 28px;
    color: rgba(0, 0, 0, 0.9);
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    border-radius: 100px;
  }
  &__play {
    &__image {
      overflow: hidden;
      margin-bottom: 0px;
      border-radius: 14px 14px 0 0;
      background: #f5f5f5;
      img {
        border-radius: 14px;
      }
    }
    &__content {
      border-radius: 0 0 14px 14px;
      background: #f5f5f5;
      height: 100px;
      padding: 20px;
    }
    &__btn {
      top: 50%;
      width: 100%;
      &--previous,
      &--next {
        width: 57px;
        height: 57px;
        background: #d9d9d9;
        border-radius: 50%;
      }
    }
  }
  &__play-1 {
    border-radius: 0 0 14px 14px;
    background: #e8e8e8;
    height: 12px;
    margin: 0 16px;
  }
  &__play-2 {
    border-radius: 0 0 14px 14px;
    background: #d9d9d9;
    height: 12px;
    margin: 0px 28px;
  }
}
/deep/.footer {
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// discover.vue?71ee574b